import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import RiskLevelSticker from 'dashboard/components/RiskLevelSticker';
import { IdPortraitClarityDetection } from 'dashboard/models/check';
import { RiskData } from 'dashboard/models/verification-check';

export const computeIdPortraitClarityDetectionMetadata = (
  check: IdPortraitClarityDetection,
): CheckMetadata => {
  const metadata = [];
  const risks = check.metadata?.['risks'];
  const clarityRiskData = risks?.find((r: RiskData) => r.reason === 'portrait_not_clear');

  if (clarityRiskData && clarityRiskData['level']) {
    metadata.push({
      label: 'Portrait Clarity Risk',
      value: RiskLevelSticker({ riskLevel: clarityRiskData['level'] }),
    });
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
